module.exports = __webpack_public_path__ + "img/img_4.d4173cc3.png";